<div
  class="gd-breadcrumbs">

  <!-- Breadcrumb -->
  <span
    *ngFor="let bread of breadcrumbs; let breadIndex = index;"
    class="gd-breadcrumbs-bread">

    <!-- Separator -->
    <span
      *ngIf="breadIndex > 0"
      class="gd-breadcrumbs-bread-separator">/</span>

    <!-- Label -->
    <a
      class="gd-breadcrumbs-bread-label"
      [class.gd-breadcrumbs-bread-label-active]="!bread.action"
      [routerLink]="bread.action && bread.action.link ? bread.action.link : undefined"
      [queryParams]="bread.action && bread.action.linkQueryParams ? bread.action.linkQueryParams : undefined">
      {{bread.label | translate}}
    </a>
  </span>

  <!-- Additional icon infos -->
  <span
    *ngFor="let breadInfo of infos"
    class="gd-breadcrumbs-bread-infos">

    <!-- Info pill -->
    <span
      class="gd-breadcrumbs-bread-infos-info"
      [matTooltip]="breadInfo.tooltip">
      {{breadInfo.label | translate}}
    </span>
  </span>
</div>
